module.exports = {
    path: '/mapping',
    component: () => import("@/modules/mapping/Mapping.vue"),
    meta: { module: "mp" },
    children: [
        {
            path: '/',
            redirect: 'scada-tags'
        },
        {
            path: 'scada-tags',
            display: 'Scada Tags',
            component: () => import('@/modules/mapping/components/ScadaTags.vue'),
            children: [
                {
                    path: 'mapping',
                    name: 'mp_mapping_scada',
                    component: () => import('@/modules/mapping/components/views/ScadaTags/ScadaMappings'),
                },
                {
                    path: 'mapping-configuration',
                    name: 'mp_mapping-configuration_scada',
                    component: () => import('@/modules/mapping/components/views/ScadaTags/MappingConfiguration'),
                },
                {
                    path: 'uploads',
                    name: 'mp_uploads_scada',
                    component: () => import('@/modules/mapping/components/views/ScadaTags/Uploads')
                },
                {
                    path: 'reference-files',
                    name: 'mp_reference-files_scada',
                    component: () => import('@/modules/mapping/components/views/ScadaTags/ReferenceFiles')
                },
                {
                    path: '',
                    alias: 'masterfile',
                    component: () => import('@/modules/mapping/components/views/ScadaTags/Masterfile'),
                    name: 'mp_masterfile_scada'
                }
            ]
        },
        {
            path: 'assets',
            display: 'Assets',
            component: () => import('@/modules/mapping/components/Assets.vue'),
            children: [
                {
                    path: 'mappings',
                    name: 'mp_mapping_assets',
                    component: () => import('@/modules/mapping/components/views/Assets/Mappings'),
                },
                {
                    path: 'uploads',
                    name: 'mp_uploads_assets',
                    component: () => import('@/modules/mapping/components/views/Assets/Uploads')
                },
                {
                    path: 'reference-files',
                    name: 'mp_reference-files_assets',
                    component: () => import('@/modules/mapping/components/views/Assets/ReferenceFiles')
                },
                {
                    path: '',
                    alias: 'masterfile',
                    component: () => import('@/modules/mapping/components/views/Assets/Masterfile'),
                    name: 'mp_masterfile_assets'
                }
            ]
        }
    ]
};



// WEBPACK FOOTER //
// ./src/modules/mapping/router.js